<template>
    <div class="share-button-wrapper" :style="shareButtonStyle" @click="shareActivityCardTrigger">
        
        <template v-if="showShareActivityCard"> <!-- 分享活动和卡片的弹窗 -->
            <ShareActivityCard :info="shareActivityCardInfo"  @emitEvent="receiveEvent" />
        </template>

    </div>
</template>

<script>

import { ShareActivityCard } from './components'
var rem = require('@/utils/rem')
export default {

    name: 'ShareButton',

    components: {

        ShareActivityCard,

    },

    props: {

        info: {
            type: Object,
            required: true,
            default: () => {
                return {}
            }
        },

        pageDetail: { // 活动数据
            type: Object,
            required: true,
            default: () => {
                return {}
            }
        },

        receiveData: { // 接收数据
            type: Object,
            required: true,
            default: () => {
                return {}
            }
        }


    },

    watch: {
        
    },

    inject: ['$$activityId', '$$activityStatus', '$$activityType', 'getEnterSource'],

    data() {

        return {

            shareButtonStyle: {},

            showShareActivityCard: false,

            shareActivityCardInfo: {},

        }

    },

    computed: {
        enterSource() {
            return this.getEnterSource();
        },

        $activityStatus() {
            return this.$$activityStatus()
        },

    },

    mounted() {

        this.init()
    },

    methods: {
        
        init() {

            this.initShareButtonStyle()

        },
        handleCss(options = {}) {
            let str= `.a${JSON.stringify(options).replace(/\"/g, '')}`
            let cssStyle  = rem.prototype.generateRem(str).toString()
            cssStyle  = cssStyle .substr(0, cssStyle .length - 1)
            cssStyle  = cssStyle .slice(7)
            return cssStyle.replace(/\,/g, ';')
        },
        initShareButtonStyle() { // 初始化分享按钮样式

            let options = {}

            let shareButton = this.info.shareConfig

            if (shareButton && shareButton.position1 && shareButton.position1.type) {
                options[`${shareButton.position1.type}`] =  `${shareButton.position1.value || 0}px`
            }

            if (shareButton && shareButton.position2 && shareButton.position2.type) {
                options[`${shareButton.position2.type}`] =  `${shareButton.position2.value || 0}px`
            }

            if (shareButton && shareButton.width) {
                options.width = `${shareButton.width}px`
            }

            if (shareButton && shareButton.height) {
                options.height = `${shareButton.height}px`
            }

            if (shareButton && shareButton.img && shareButton.img.url) {
                options = Object.assign(options, {
                    backgroundImage: `url(${shareButton.img.url})`,
                    backgroundSize: `100% 100%`,
                    backgroundPosition: `0px 0px`,
                })
            }

            this.shareButtonStyle = this.handleCss(options)
            // this.shareButtonStyle = options

        },

        shareActivityCardTrigger() { // 点击分享按钮

            this.$log.senLog({
                pointID: '12010010',
                eventType: 2,
                businessData: {
                    activityType: this.$$activityType || '',
                    activityId: this.$$activityId || '',
                    enterSource: this.enterSource || '',
                }
            })
           
            let status = this.$activityStatus
            if (status == 2 || status == 3) {
               this.$emit('emitEvent', {
                type: 'shareActivityEvent',
                data: {
                    shareType: 'shareActivityCard'
                },
                options: null
            })
            } else if (status == 4) {
                this.toast('活动已经结束 感谢您的关注')
            }
            
        },

        closeShareActivityCard() { // 关闭分享卡片或活动
            this.shareActivityCardInfo = {}
            this.showShareActivityCard = false
        },

        shareActivity(data, options) { // 分享活动
            this.$emit('emitEvent', {
                type: 'shareActivityEvent',
                data: {
                    shareType: 'shareActivity'
                },
                options
            })
        },

        shareCard(data, options) { // 分享卡片
            this.$emit('emitEvent', {
                type: 'shareActivityEvent',
                data: {
                    shareType: 'shareCard',
                    cardId: data.cardId
                },
                options
            })
        },

        toast(txt, duration) { // 封装统一的信息处理函数
            this.$toast({
                styles: {
                    maskColor: "rgba(0,0,0,0)",
                    background: "rgba(0,0,0,0.4)",
                    messageColor: "#fff"
                },
                content: txt,
                duration: duration || 2000
            })
        },
        

        receiveEvent(e) { // 接收子组件的事件
            let {
                type,
                data,
                options
            } = JSON.parse(JSON.stringify(e))
            this[type] && this[type](data, options)
        }



    }
}
</script>

<style  lang="scss" scoped>

.share-button-wrapper {
    margin: 0;
	padding: 0;
	box-sizing: border-box;
	position: absolute;
}

</style>